import type { SupWeb3Asset } from "@/types";
import Image from "next/image";
import React from "react";

import { SupText } from "@repo/core-ui";

interface UiChipVaultTooltipProps {
  assets: SupWeb3Asset[];
  vaultId: string;
}

export default function UiChipVaultTooltip({ assets, vaultId }: UiChipVaultTooltipProps) {
  return (
    <div className="space-y-2">
      {assets.map((asset, index) => (
        <div key={`${vaultId}-${asset.symbol}-${index}`} className="flex items-center space-x-1">
          <Image
            className="h-8 w-8 overflow-hidden rounded-full bg-neutral-950 object-cover object-center"
            height={16}
            alt={asset.name}
            width={16}
            src={asset.image ?? "/assets/img/placeholder/token.svg"}
          />
          <SupText variant="subtitle1" as="div" className="text-[16px] leading-4 text-neutral-950">
            {asset.symbol}
          </SupText>
        </div>
      ))}
    </div>
  );
}
